// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Yz83","field":"styles_field__rEpr5","fieldCol":"styles_fieldCol__LRfSA","diffCol":"styles_diffCol__1rpbP","diff":"styles_diff__3XdJf"};